module.exports = __webpack_public_path__ + "img/havefun_modelcourse_1_en.adff8d99.jpg";